import ApiService from '../../components/api_services/apiService.jsx';
import { CheckCircle2 } from 'lucide-react';
import { toggleCheckedItem } from '../../store/encyclopediaTabSlice';
import EncyclopediaRowActions from './EncyclopediaRowActions';

// Helper function to format date
const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0].split('-').reverse().join('-');
  } catch (e) {
    return dateString;
  }
};

// Helper function to format address
const formatAddress = (article) => {
  if (!article) return '';
  const parts = [];
  if (article.street) parts.push(article.street);
  if (article.street_number) parts.push(article.street_number);
  if (article.post_code) parts.push(article.post_code);
  if (article.city) parts.push(article.city);
  return parts.join(', ') || article.address || '';
};

export const fetchArticles = async (
  sortBy,
  sortDirection,
  currentPage,
  dispatch,
  setMaxPages,
  setRows,
  setTotalCount,
  setArticlesData,
  checkedItems,
  searchQuery,
  title,
  dateFrom,
  dateTo,
  address,
  authorName,
  userId,
  pinUrl,
  status,
  setArticlesMap,
  setArticlesList,
  onAcceptArticle,
  onEditArticle,
  onDeleteArticle
) => {
  try {
    // Build query parameters
    const params = {
      pageNumber: currentPage,
      pageSize: 20,
      ...(sortBy && sortDirection && { sortBy, sortDirection }),
      ...(searchQuery && { searchQuery }),
      ...(title && { title }),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...(address && { address }),
      ...(authorName && { authorName }),
      ...(userId && { userId }),
      ...(pinUrl && { pinUrl }),
      ...(status && { status }),
    };

    const response = await ApiService.getArticles(params);

    const articles = response.data || [];
    const totalCount = response.total_count || 0;
    const totalPages = response.max_page || 1;

    dispatch(setMaxPages(totalPages));
    dispatch(setTotalCount(totalCount));

    // Store article metadata for select all functionality
    const articlesData = articles.map((article) => article.id);
    if (setArticlesData) {
      setArticlesData(articlesData);
    }
    
    // Store full article data for access in component
    const articlesMap = {};
    articles.forEach((article) => {
      articlesMap[article.id] = article;
    });
    // Pass articlesMap back through a callback if needed
    // For now, we'll store it in the service and access via a getter
    if (setArticlesMap) {
      setArticlesMap(articlesMap);
    }
    
    // Store full articles list for sidebar
    if (setArticlesList) {
      setArticlesList(articles);
    }

    // Map articles to table rows
    const mappedRows = articles.map((article) => {
      const isChecked = checkedItems.includes(article.id);

      return [
        <input
          key={`checkbox-${article.id}`}
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            dispatch(toggleCheckedItem(article.id));
          }}
        />,
        article.id || '',
        article.title || '',
        formatDate(article.createdAt),
        formatAddress(article),
        article.authorName || '',
        article.pinUrl ? (
          <CheckCircle2 size={16} className="pin-checkmark" />
        ) : (
          ''
        ),
        <span
          key={`status-${article.id}`}
          className={`status-badge status-${article.status?.toLowerCase()}`}
        >
          {article.status === 'PENDING'
            ? 'do weryfikacji'
            : article.status === 'APPROVED'
            ? 'aktywny'
            : article.status === 'REJECTED'
            ? 'odrzucony'
            : article.status || ''}
        </span>,
        <EncyclopediaRowActions
          key={`actions-${article.id}`}
          onAccept={() => {
            if (onAcceptArticle) {
              onAcceptArticle(article.id);
            }
          }}
          onEdit={() => {
            if (onEditArticle) {
              onEditArticle(article.id);
            }
          }}
          onDelete={() => {
            if (onDeleteArticle) {
              onDeleteArticle(article.id);
            }
          }}
        />,
      ];
    });

    setRows(mappedRows);
  } catch (error) {
    console.error('Błąd podczas pobierania artykułów:', error);
    setRows([]);
  }
};

